import {
  Tooltip as ArkTooltip,
  type TooltipRootProps as ArkTooltipRootProps,
} from '@ark-ui/react/tooltip'
import { useTheme } from '~/hooks/use-theme'
import type {
  AlignedPlacement,
  TokenSpacingKeys,
  TooltipPlacement,
  TooltipStrategy,
} from './tooltip.type'

export type TooltipRootProps = Omit<ArkTooltipRootProps, 'positioning'> & {
  /**
   * Define a posição do tooltip em relação ao elemento alvo.
   * @default 'bottom'
   */
  side?: TooltipPlacement | AlignedPlacement
  /**
   * Distância do tooltip em relação ao elemento alvo.
   * @default 'spacingStackTwopulse' = 8px
   */
  distance?: keyof TokenSpacingKeys
  /**
   * Define a estratégia de posicionamento do tooltip.
   * @default 'fixed'
   */
  strategy?: TooltipStrategy
}

export function TooltipRoot({
  children,
  side = 'bottom',
  distance = 'spacingStackTwopulse',
  strategy = 'fixed',
  open,
  disabled,
  ...props
}: TooltipRootProps) {
  const theme = useTheme()

  return (
    <ArkTooltip.Root
      positioning={{
        placement: side,
        offset: {
          mainAxis: theme[distance],
          crossAxis: 0,
        },
        strategy,
      }}
      interactive
      data-testid="tooltip-root"
      open={disabled ? false : typeof open !== 'undefined' ? open : undefined}
      disabled={disabled}
      {...props}
    >
      {children}
    </ArkTooltip.Root>
  )
}

TooltipRoot.displayName = 'TooltipRoot'
